export default "__VITE_ASSET__CGWFSO9J__"